import { apiClient, fastApiClient } from "../App";

// Department List
export const getDepartments = () => {
  return apiClient.get("/departments/");
};

// Human Risk Scorecard
export const getHumanRiskScorecard = (department = "all") => {
  return fastApiClient.get("/dashboard/human-risk-scorecard", {
    params: department !== "all" ? { department } : {},
  });
};